export default __webpack_public_path__ + "static/media/document-uploaded.icon.934a2998.svg";